import {
  recalculateWorkerShiftHours,
  recalculateWorkerDayHours,
  recalculateWorkerHours,
} from '../../utils/timekeeping/shiftCalculations';
import { useShiftManagement } from './useShiftManagement';

/**
 * Wrapper hook for worker (WorkerTimesheet) shift management
 * Uses worker field names (regularTime, startTime, etc.)
 * Only provides removeShiftFromDay (no add functionality for workers)
 * 
 * @param {Function} setCompletedShifts - State setter for completed shifts data
 * @returns {Object} - Shift management functions (only removeShiftFromDay)
 */
export const useWorkerShiftManagement = (setCompletedShifts) => {
  return useShiftManagement(setCompletedShifts, {
    fieldNames: {
      timeStart: 'startTime',
      timeEnd: 'finishTime',
      hoursRegular: 'regularTime',
      hoursOvertime: 'overtime',
      hoursDoubleTime: 'doubleTime',
    },
    recalculateShiftHoursFn: recalculateWorkerShiftHours,
    recalculateDayHoursFn: recalculateWorkerDayHours,
    recalculateAllHoursFn: recalculateWorkerHours,
    // No defaultShift - workers cannot add shifts, only delete
    defaultShift: null,
  });
};
